import { render, staticRenderFns } from "./PrimaCardRow.vue?vue&type=template&id=4c64bd83&"
import script from "./PrimaCardRow.vue?vue&type=script&lang=js&"
export * from "./PrimaCardRow.vue?vue&type=script&lang=js&"
import style0 from "./PrimaCardRow.vue?vue&type=style&index=0&id=4c64bd83&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports